import React from 'react';
import FavoritesContainer from './FavoritesContainer';
import PageContainer from '../PageContainer';
import Header from '../Header';
import Footer from '../Footer';
import '../../styles/favorites.scss';

const Favorites = () => {
  return (
    <PageContainer>
      <Header title="Favorites" showInfo={false} showFavorite={false} />
      <FavoritesContainer />
      <Footer />
    </PageContainer>
  );
};

export default Favorites;
